const THUMBNAILS_BASE = '/images/thumbnails/products';

/**
 * Maps product IDs to their thumbnail image filename.
 * Thumbnails are 400px-wide optimized versions for card displays.
 */
const productThumbnails: Record<string, string> = {
  'black-dog-tag': 'black-dog-tag-card.png',
  'black-card': 'black-card-card.png',
  'black-wallet': 'black-wallet-card.png',
};

/**
 * Maps product IDs to their template thumbs directory and curated slideshow images.
 * One representative thumb per template category, using 200w webp for performance.
 * Images are from /images/templates/{product-dir}/thumbs/
 */
const productSlideshowConfig: Record<string, { dir: string; thumbs: readonly string[] }> = {
  'black-dog-tag': {
    dir: 'dog-tag',
    thumbs: [
      'pet-dog-tag-200w.webp',
      'military-memorial-200w.webp',
      'portrait-200w.webp',
      'crest-emblem-200w.webp',
      'luggage-tag-200w.webp',
      'plant-label-200w.webp',
      'custom-prompt-200w.webp',
      'qr-code-centered-200w.webp',
    ],
  },
  'black-card': {
    dir: 'card',
    thumbs: [
      'business-card-200w.webp',
      'portrait-200w.webp',
      'crest-emblem-200w.webp',
      'luggage-tag-200w.webp',
      'plant-label-200w.webp',
      'custom-prompt-200w.webp',
    ],
  },
  'black-wallet': {
    dir: 'wallet',
    thumbs: [
      'wallet-card-200w.webp',
      'metal-art-200w.webp',
      'portrait-200w.webp',
      'crest-emblem-200w.webp',
      'luggage-tag-200w.webp',
      'plant-label-200w.webp',
      'custom-prompt-200w.webp',
    ],
  },
};

/**
 * Returns the thumbnail image path for a product card.
 * Falls back to the provided fallback path if no thumbnail exists.
 */
export function getProductThumbnail(productId: string, fallback?: string): string {
  const filename = productThumbnails[productId];
  if (filename) return `${THUMBNAILS_BASE}/${filename}`;
  return fallback ?? '';
}

/**
 * Returns an array of template thumb paths for a product's hover slideshow.
 */
export function getProductSlideshowImages(productId: string): readonly string[] {
  const config = productSlideshowConfig[productId];
  if (!config) return [];
  return config.thumbs.map((f) => `/images/templates/${config.dir}/thumbs/${f}`);
}
